import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PerceptionItem from './PerceptionItem';
import {Box, BoxContent, NoData, MainHeading, Description} from '../../StyledComponents';

/**
* Colors
*/
const themeColors = ['#00ae89', '#df5c5e', '#ff6000', '#2575bb', '#7b4172', '#e7969c', '#a55094', '#843c39'];
const themeColorsFaded = ['#156552', '#861823', '#b94702', '#21456D'];

/**
* Styled components
*/

const PerceptionViewContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  > div:last-child {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
`;



const PerceptionContainer = styled.div`
  padding-left: 12%;
  padding-right: 12%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    justify-content: center;

    > div {
      width: 100%;
      display: flex;
      flex-direction: column;
      max-height: 300px;
    }
  }

  @media only screen and (max-width: 991px) {
    padding-left: 10%;
    padding-right: 10%;

    > div {

      > div {
        flex-direction: row;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }

  @media only screen and (max-width: 524px) {
    > div {
      > div {
        flex-direction: column;
      }
    }
  }

  @media print {
    > div {
      > div {
        flex-direction: row;
      }
    }
  }

`;

const PerceptionReportBox = styled.div`
  padding-left: 5%;
  padding-right: 5%;

  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }

  h2 {
    text-transform: uppercase;
    margin-top: 0;

    span.perception-report-outakes {
      font-weight: 300;
    }
  }

  p {
    border-bottom: 1px solid #444;
    margin: 0;
    padding-top: 8px;
    padding-bottom: 10px;
    line-height: 1.9;
  }

  p:last-child {
    border: none;
  }

  @media only screen and (max-width: 1200px) {
    p {
      line-height: 1.7;
    }
  }

  @media only screen and (max-width: 1150px) {
    p {
      line-height: 1.9;
    }
  }
`;

const PerceptionRow = styled.div`
  display: flex;
  padding-bottom: 10px;

  :last-child {
    padding-bottom: 0;
  }

  @media only screen and (max-width: 991px) {
    padding-top: 30px;
    padding-bottom: 10px;
    width: 50%;
  }

  @media only screen and (max-width: 524px) {
    padding-top: 30px;
    padding-bottom: 20px;
    width: 100%;
  }

  @media print {
    width: 50%;
  }

`;

const PerceptionBox = styled.div`
  display: flex;

  > div {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  @media only screen and (max-width: 991px) {
  }

  @media only screen and (max-width: 524px) {
  }
`;


/**
* Class PerceptionView
*/
class PerceptionView extends Component {
  getSentence(observationProperty, observationLevel, outakeProperty, outakeLevel) {
    let sentences;
    if(observationProperty === 'neutral' && observationLevel === 'high' && outakeProperty === 'price' && outakeLevel === 'low') {
      sentences = <p className="small-font-size">High number of <span className="tiny-font-size report-tag neutral-tag">neutral</span> meaning price could be higher or at this level.</p>
    } else if(observationProperty === 'unaware' && observationLevel === 'high' && outakeProperty === 'positive' && outakeLevel === 'low') {
      sentences = <p className="small-font-size"><span className="tiny-font-size report-tag">converting</span> as many of the <span className="tiny-font-size report-tag unaware-tag">unaware</span> customers to <span className="tiny-font-size report-tag positive-tag">positive</span> as possible.</p>
    }

    return sentences;
  }

  renderPerceptionItems(data) {
    let status1 = Object.keys(data)[0];
    let status2 = Object.keys(data)[1];
    let status3 = Object.keys(data)[2];
    let status4 = Object.keys(data)[3];
    let reportMode = this.props.reportMode;

    return (
      <div>
        <PerceptionRow>
          <PerceptionBox className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <PerceptionItem perceptionValue={data[status1]} perceptionStatus={status1} perceptionColor={(data[status1] > 50 || !reportMode) ? themeColors[0] : themeColorsFaded[0]} perceptionReport={reportMode} />
          </PerceptionBox>

          <PerceptionBox className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <PerceptionItem perceptionValue={data[status2]} perceptionStatus={status2} perceptionColor={(data[status2] > 50 || !reportMode) ? themeColors[1] : themeColorsFaded[1]} perceptionReport={reportMode} />
          </PerceptionBox>
        </PerceptionRow>

        <PerceptionRow>
          <PerceptionBox className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <PerceptionItem perceptionValue={data[status3]} perceptionStatus={status3} perceptionColor={(data[status3] > 50 || !reportMode) ? themeColors[2] : themeColorsFaded[2]} perceptionReport={reportMode} />
          </PerceptionBox>

          <PerceptionBox className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <PerceptionItem perceptionValue={data[status4]} perceptionStatus={status4} perceptionColor={(data[status4] > 50 || !reportMode) ? themeColors[3] : themeColorsFaded[3]} perceptionReport={reportMode} />
          </PerceptionBox>
        </PerceptionRow>
      </div>
    )
  }

  renderReportDetails(data) {
    return (
      <PerceptionReportBox>
        <h2 className="normal-font-size">Perception <span className="perception-report-outakes small-font-size">Key outakes</span></h2>
        {this.getSentence(data[0].observation.property, data[0].observation.level, data[0].outtake.property, data[0].outtake.level)}
        {this.getSentence(data[1].observation.property, data[1].observation.level, data[1].outtake.property, data[1].outtake.level)}
      </PerceptionReportBox>
    )
  }

  render() {
      const { data, dataReport, reportMode } = this.props;

      const placeholderData = {
        "type": "perception",
        "title": "Perception",
        "perception": {
          "positive": 14,
          "negative": 12,
          "neutral": 70,
          "unaware": 4
        }
      };

      const _data = data || placeholderData;
      const disabled = !data;

      return (
        <Box>
          <PerceptionViewContainer className={reportMode ? 'show-report-details' : ''}>
              <MainHeading>{_data && _data.title}</MainHeading>
              <Description>{this.props.description}</Description>
            <BoxContent disabled={disabled}>
              {reportMode && _data && dataReport ? this.renderReportDetails(dataReport) : ''}

              <PerceptionContainer>
                <div>
                  {_data && _data.perception ? this.renderPerceptionItems(_data.perception) : <p>"No data"</p>}
                </div>
              </PerceptionContainer>
            </BoxContent>
            {disabled && <NoData/>}
          </PerceptionViewContainer>
        </Box>
      );

    }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid
    };
}

export default connect(mapStateToProps)(PerceptionView);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/PerceptionView.js